'use strict';var _desc,_value,_class;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const ex=require('pulsar-utils/dist-es6/ex');
const{HandleUncaughtErrors:HandleUncaughtErrors}=require('../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const PromiseQueue=require('promise-queue');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');
const StickySettings=require('../../../dist-es6/shared/domain/stickySettings');
const UncaughtErrorHandler=require('../../../dist-es6/client/services/uncaughtErrorHandler');let

DisplaySettingsService=function(_BaseService){_inherits(DisplaySettingsService,_BaseService);
function DisplaySettingsService(socketService,uncaughtErrorHandler){_classCallCheck(this,DisplaySettingsService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._socketService=socketService;
_this._uncaughtErrorHandler=uncaughtErrorHandler;

const maxConcurrency=1;
const maxQueueLength=Infinity;
_this._oneByOneQueue=new PromiseQueue(maxConcurrency,maxQueueLength);

_this.reset();return _this;
}DisplaySettingsService.prototype.

reset=function reset(){
this._persistedSettings=

null;

this._stickySettings=

null;

this._renderCache={
columnWidthForTimelineScheduleGraph:null};

};DisplaySettingsService.prototype.





incorporateLatestSettingsFromBackend=function incorporateLatestSettingsFromBackend(settings){




this._persistedSettings=settings;


this._stickySettings=ex(this._stickySettings).otherwise(this._wrapStickySettings(StickySettings.fromMongo(this._persistedSettings.stickySettings)));
};DisplaySettingsService.prototype.

_wrapStickySettings=function _wrapStickySettings(stickySettings){
return new StickySettingsWrapper(stickySettings,this._socketService,this._uncaughtErrorHandler,this._oneByOneQueue);
};DisplaySettingsService.prototype.













toggleSidebarVisibility=function toggleSidebarVisibility(){
this.stickySettings.set('groupsSidebarVisible',!this.stickySettings.get('groupsSidebarVisible'));
};DisplaySettingsService.prototype.

setMultiViewSelection=function setMultiViewSelection(stickyId,selectionIndex){
this.stickySettings.set(`${stickyId}TabSelection`,selectionIndex);
};DisplaySettingsService.prototype.

getMultiViewSelectionFor=function getMultiViewSelectionFor(stickyId){
return this.stickySettings.get(`${stickyId}TabSelection`);
};_createClass(DisplaySettingsService,[{key:'renderCache',get:function(){return this._renderCache}},{key:'isLoaded',get:function(){return _.exists(this._persistedSettings)}},{key:'use24HourTimeline',get:function(){return this._persistedSettings.use24HourTimeline}},{key:'stickySettings',get:function(){return this._stickySettings}}]);return DisplaySettingsService}(BaseService);let


StickySettingsWrapper=(_class=function(){
function StickySettingsWrapper(stickySettings,socketService,uncaughtErrorHandler,oneByOneQueue){_classCallCheck(this,StickySettingsWrapper);
_.ensureInstanceOf(StickySettings,stickySettings);
_.ensureInterface(['sendAndWaitForResponse'],socketService);
_.ensureInstanceOf(UncaughtErrorHandler,uncaughtErrorHandler);
_.ensureInstanceOf(PromiseQueue,oneByOneQueue);

uncaughtErrorHandler.applyTo(this);

this._stickySettings=stickySettings;
this._socketService=socketService;
this._oneByOneQueue=oneByOneQueue;
}StickySettingsWrapper.prototype.

get=function get(setting){
return this._stickySettings[setting];
};StickySettingsWrapper.prototype.

set=function set(setting,value){
if(_.isEqual(this._stickySettings[setting],value)){
return;
}

const oldVal=this._stickySettings[setting];

this._stickySettings[setting]=value;





if(this._stickySettings[setting]===oldVal){



return;
}





return this._fireAndForgetStickySettingUpdate(setting,value);
};StickySettingsWrapper.prototype.


_fireAndForgetStickySettingUpdate=function(){var ref=_asyncToGenerator(function*(setting,value){var _this2=this;
yield this._oneByOneQueue.add(_asyncToGenerator(function*(){
const response=yield _this2._socketService.sendAndWaitForResponse('SetStickySettings',{[setting]:StickySettings.serialize(setting,value)});
if(!SocketResponse.succeeded(response)){
throw new Error(`SetStickySettings failed: ${response.status}`);
}
}));
});function _fireAndForgetStickySettingUpdate(setting,value){return ref.apply(this,arguments)}return _fireAndForgetStickySettingUpdate}();return StickySettingsWrapper}(),(_applyDecoratedDescriptor(_class.prototype,'_fireAndForgetStickySettingUpdate',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_fireAndForgetStickySettingUpdate'),_class.prototype)),_class);


module.exports=DisplaySettingsService;
//# sourceMappingURL=displaySettingsService.js.map
